import React from 'react';

function Skills() {
  return (
    <div>
      these are all of my technical skills wow
      <ul>
        <li>javascript</li>
        <li>react</li>
        <li>.net</li>
        <li>sql</li>
        <li>azure functions</li>
      </ul>
    </div>
  )
}

export default Skills;